module.exports = __webpack_public_path__ + "static/media/highpoint-logo.00e20d13.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/logo/highpoint-logo.png
// module id = 945
// module chunks = 0